import { parseLinkHeader } from '@web3-storage/parse-link-header'

import { toAmount } from './currency.js'
import Raven from 'raven-js'
import _uniqBy from 'lodash/uniqBy.js'

// Vue remove reactivity
export function inert (x) {
  return JSON.parse(JSON.stringify(x))
}

// Number range
export function toBounds (n, fixMinMax = false) {
  if (!n || typeof n !== 'string') {
    return { lower_bound: 0, upper_bound: 0 }
  }

  var out = {}
  n = n.replace(/[^\d-]/g, '').split('-').map((n) => parseInt(n))

  if (fixMinMax) {
    out.lower_bound = n[1] < n[0] ? n[1] : n[0]
    out.upper_bound = n[1] > n[0] ? n[1] : n[0]
  } else {
    out.lower_bound = n[0]
    out.upper_bound = n[1] ? n[1] : n[0]
  }

  return out
}

export function fromBounds (b) {
  if (!b) {
    return
  }

  // It's an array of bounds
  if (Array.isArray(b)) {
    const sorted = inert(b)
    sorted.sort((a, b) => (b.date || '').localeCompare(a.date || ''))
    return fromBounds(sorted[0])
  }

  // It's a range
  if (b.lower_bound && b.upper_bound && b.lower_bound !== b.upper_bound) {
    return b.lower_bound + ' - ' + b.upper_bound
  }

  // It's just a number
  return b.lower_bound || b.upper_bound || ''
}

// Date & time
export const MONTHS = 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sept,Oct,Nov,Dec'.split(',')

export const EMBED_SERVICE_HANDLERS = {
  youtube: id => {
    const embedUrl = `https://www.youtube.com/embed/${id}`
    return `<iframe src="${embedUrl}" frameborder="0" allow="fullscreen" allowfullscreen="true"></iframe>`
  },
  vimeo: id => {
    const embedUrl = `https://player.vimeo.com/video/${id}`
    return `<iframe src="${embedUrl}" frameborder="0" allow="fullscreen" allowfullscreen="true"></iframe>`
  },
  fallback: embedUrl => {
    return `<iframe src="${embedUrl}" frameborder="0" allow="fullscreen" allowfullscreen="true"></iframe>`
  },
}

export function toMonthYear (d) {
  // d = new Date(Date.parse(d))
  d = parseShortIso8601Date(d)

  return 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sept,Oct,Nov,Dec'.split(',')[d.getMonth()] + ', ' + d.getFullYear()
}

function parseShortIso8601Date (input) {
  var parts = input.split('-')

  // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
  return new Date(parts[0], parts[1] - 1, 1) // Note: months are 0-based
}

export function toEndOfMonth (str) {
  var parts = str.split('-')
  return new Date(parts[0], parts[1], 0, 12).toUTC().slice(0, 10)
}

export function timeAgo (d) {
  if (typeof d === 'string') {
    d = new Date(d)
  }
  if (!d || typeof d.getMonth !== 'function') {
    return
  }
  const seconds = Math.abs(Date.now() - d.valueOf()) / 1000

  const MINUTE = 60
  const HOUR = MINUTE * 60
  const DAY = HOUR * 24
  const WEEK = DAY * 7
  const MONTH = DAY * 30
  const YEAR = DAY * 365

  const [value, unit] = seconds < MINUTE
    ? [Math.round(seconds), 'second']
    : seconds < HOUR
      ? [Math.round(seconds / MINUTE), 'minute']
      : seconds < DAY
        ? [Math.round(seconds / HOUR), 'hour']
        : seconds < WEEK
          ? [Math.round(seconds / DAY), 'day']
          : seconds < MONTH
            ? [Math.round(seconds / WEEK), 'week']
            : seconds < YEAR
              ? [Math.round(seconds / MONTH), 'month']
              : [Math.round(seconds / YEAR), 'year']

  return value + ' ' + unit + (value > 1 ? 's' : '')
}

// URLs

export function toQuery (state) {
  return Object.keys(state).filter(key => {
    return state[key] && String(state[key])
  }).map(function (key) {
    return key + '=' + encodeURIComponent(state[key])
  }).join('&')
}

/* eslint-disable */
export function fromQuery (query) {
  var match
  var output = {}
  var pl = /\+/g
  var search = /([^&=]+)=?([^&]*)/g
  var decode = function (s) {
    return decodeURIComponent(s.replace(pl, ' '))
  }
  query = query || window.location.search.substring(1)

  while (match = search.exec(query)) {
    output[decode(match[1])] = decode(match[2])
  }
  return output
}

/* eslint-enable */

// Parse link header
export function getPaging (header) {
  if (typeof header === 'function') {
    return parseLinkHeader(header('link'))
  }
  return header && header.map && header.map.Link && parseLinkHeader(header.map.Link[0])
}

// https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
export function isIE11 () {
  return !!window.MSInputMethodContext && !!document.documentMode
}

// https://github.com/jfromaniello/li
// MIT 2014 - JOSE F. ROMANIELLO
export function parseLink (linksHeader) {
  var result = {}
  var entries = linksHeader.split(',')
  // compile regular expressions ahead of time for efficiency
  var relsRegExp = /\brel=(?:"([^"]+)"|([^";,]+)(?:[;,]|$))/
  var keysRegExp = /([^\s]+)/g
  var sourceRegExp = /^<(.*)>/

  for (var i = 0; i < entries.length; i++) {
    var entry = entries[i].trim()
    var source = sourceRegExp.exec(entry)
    var rels = relsRegExp.exec(entry)
    if (source && rels) {
      var href = source[1]
      var rel = rels[1] || rels[2]
      var keys = rel.match(keysRegExp)
      var kLength = keys.length
      for (var k = 0; k < kLength; k += 1) {
        result[keys[k]] = href
      }
    }
  }

  return result
}

/* Escape html entities avoid xss <script> */
export function toEntities (str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

// Similar to Underscore

export function _without (arr, elem) {
  arr.splice(arr.indexOf(elem), 1)
  return arr
}

/*!
 * array-unique <https://github.com/jonschlinkert/array-unique>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */
export function _unique (arr) {
  if (!Array.isArray(arr)) {
    console.warn(arr)
    throw new TypeError('array-unique expects an array.')
  }

  var len = arr.length
  var i = -1

  while (i++ < len) {
    var j = i + 1

    for (; j < arr.length; ++j) {
      if (arr[i] === arr[j]) {
        arr.splice(j--, 1)
      }
    }
  }
  return arr
}

export function _uniqueBy (arr, key) {
  var flags = {}
  var uniques = []
  var i = 0
  for (; i < arr.length; ++i) {
    if (!flags[arr[i][key]]) {
      flags[arr[i][key]] = true
      uniques.push(arr[i])
    }
  }
  return uniques
}

export function _pick (obj, keys) {
  var result = {}
  for (const key in obj) {
    if (keys.indexOf(key) > -1) {
      result[key] = obj[key]
    }
  }
  return result
}

export function _intersect (arr1, arr2) {
  return arr1.filter(function (n) {
    return arr2.indexOf(n) !== -1
  })
}

export default function (argument) {
  console.warn('Add some {curlyBraces} to your import!')
}

/* Changes */

function address (c) {
  try {
    c = JSON.parse(c)
    return (c.street || '') + ' ' + (c.number || '') + (c.number || c.street ? '\n' : '') + (c.zip || '') + ' ' + (c.city || '') + (c.country_code ? ', ' + c.country_code : '')
  } catch (e) {
  }
  return c
}

function fromLocation (c) {
  try {
    c = JSON.parse(c)
    return 'Latitude: ' + c.lat + '\nLongitude: ' + c.lon
  } catch (e) {
  }
  return c
}

function investors (c) {
  try {
    c = JSON.parse(c)
    return c.map(i => i.name).join(', ')
  } catch (e) {
  }
  return c
}

function fundingRounds (c) {
  try {
    c = JSON.parse(c)
    return c.map(f => (f.original_currency || '') + ' ' + toAmount(f.original_capital_raised) + ' ' + f.type + ' ' + f.started_at + (f.investors ? '\n* ' + f.investors : '')).join('\n')
  } catch (e) {
  }
  return c
}

function fromArray (c) {
  try {
    c = JSON.parse(c)
    return c.join(', ')
  } catch (e) {
  }
  return c
}

function fromObject (c) {
  try {
    c = JSON.parse(c)
    return Object.keys(c).map(key => key + ' ' + c[key]).join('\n')
  } catch (e) {
  }
  return c
}

function fromObjectArray (c) {
  try {
    c = JSON.parse(c)
    return c.map(f => Object.keys(f).map(key => key + ' ' + f[key]).join(',\n')).join('\n')
  } catch (e) {
  }
  return c
}

export function fromChange (c) {
  c.previous_value = c.previous_value || ''
  c.value = c.value || ''
  switch (c.property) {
    case 'address':
      c.previous_value = address(c.previous_value)
      c.value = address(c.value)
      return c
    case 'funding_rounds':
      c.previous_value = fundingRounds(c.previous_value)
      c.value = fundingRounds(c.value)
      return c
    case 'investors':
      c.previous_value = investors(c.previous_value)
      c.value = investors(c.value)
      return c
    case 'location':
      c.previous_value = fromLocation(c.previous_value)
      c.value = fromLocation(c.value)
      return c
  }
  if (c.value.startsWith('[{"')) {
    c.previous_value = fromObjectArray(c.previous_value)
    c.value = fromObjectArray(c.value)
  } else if (c.value.startsWith('{"')) {
    c.previous_value = fromObject(c.previous_value)
    c.value = fromObject(c.value)
  } else if (c.value.startsWith('["')) {
    c.previous_value = fromArray(c.previous_value)
    c.value = fromArray(c.value)
  }
  return c
}

export function fromAgent (a) {
  switch (a) {
    case 'datascouts web application':
      return 'DataScouts platform'
    case 'cleaning':
      return 'Data cleaner'
  }
  return a
}

export function haveInCommon (a, b, keys) {
  for (var i = keys.length - 1; i >= 0; i--) {
    if (a[keys[i]] !== b[keys[i]]) {
      return false
    }
  }
  return true
}

export function truncate (string, maxLength) {
  return string && string.length > maxLength
    ? string.substring(0, maxLength - 3) + '...'
    : string || ''
}

export function addressLine (a) {
  if (!a) {
    return ''
  }

  var line = ((a.street ? a.street + (a.number ? ' ' + a.number : '') + ', ' : '') + (a.zip || '') + ' ' + (a.city || '')).trim()

  if (line) {
    line += (a.country ? ' - ' + a.country : '')

    return line
  }

  return a.country
}

export function addressLines (a) {
  if (!a) {
    return ''
  }
  return ((a.street ? a.street + (a.number ? ' ' + a.number : '') + ' \n' : '') + (a.zip || '') + ' ' + (a.city || '') + (a.city && a.country ? ',' : '') + (a.country ? ' \n' + a.country : '')).trim()
}

export function isJson (string) {
  try {
    JSON.parse(string)
  } catch (e) {
    return false
  }
  return true
}

// Idea: move all report related configuration to a state file and make it part of the vue state
export function getAllReportTemplates () {
  if (!window.config.report_settings) {
    return []
  }

  // TODO: Check if this is filtered for non-owners based on the permissions
  return window.config.report_settings
}

/**
 * @param productsOnly - Return only report fields from report templates applicable for products
 */
export function getAllReportFields (productsOnly = false) {
  if (!window.config.report_settings) {
    return []
  }

  var reportFields = []

  for (var index = 0; index < window.config.report_settings.length; index++) {
    var reportTemplate = window.config.report_settings[index]

    if (productsOnly && !reportTemplate.enabled_for_product) {
      continue
    }

    for (let fieldIndex = 0; fieldIndex < reportTemplate.reportFields.length; fieldIndex++) {
      reportFields.push(reportTemplate.reportFields[fieldIndex])
    }
  }

  return reportFields
}

export function getReportFieldById (reportFieldId) {
  var reports = getAllReportFields()

  reports = reports.filter(reportField => reportField.id == reportFieldId)

  if (reports.length > 0) {
    return reports[0]
  }
}

// Return the field by its report_field_{id} identifier
export function getReportFieldByReportIdentifier (reportFieldIdentifier) {
  var reports = getAllReportFields()

  var id = reportFieldIdentifier.replace('report_field_', '')

  reports = reports.filter(reportField => reportField.id == id)

  if (reports.length > 0) {
    return reports[0]
  }
}

export function getReportTemplateByReportIdentifier (reportFieldIdentifier) {
  var reports = getAllReportTemplates()

  var id = reportFieldIdentifier.replace('report_template_', '')

  reports = reports.filter(reportField => reportField.id == id)

  if (reports.length > 0) {
    return reports[0]
  }
}

// Return the fields that can are belonging to a specific type
export function getReportFieldsByTypes (reportFieldTypes) {
  var reports = getAllReportFields()

  reports = reports.filter(reportField => reportFieldTypes.includes(reportField.type))

  return reports.map(reportField => 'report_field_' + reportField.id)
}

export function convertToYoutubeEmbed (url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)

  var id = (match && match[2].length === 11)
    ? match[2]
    : null

  if (!id) {
    return
  }

  return 'https://www.youtube.com/embed/' + id
}

export function convertToVimeoEmbed (url) {
  var pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g

  if (pattern.test(url)) {
    return 'player.vimeo.com/video/' + $1
  }
}

export function unArrayify (value) {
  if (Array.isArray(value)) {
    return value.length > 0 ? value[0] : ''
  } else {
    return value
  }
}

export function isRelevantForActor (property, actor) {
  switch (property) {
    case 'seniority':
    case 'role':
    case 'education_history':
    case 'courses':
    case 'linkedin_follower_count':
    case 'honors_and_awards':
      return ['Person'].includes(actor.actor_type)
    case 'type':
      return ['LegalEntity'].includes(actor.actor_type)

    case 'funding_rounds':
    case 'exit_round':
      return (actor.funding_structure || []).includes('Equity capital') || (actor.funding_rounds && actor.funding_rounds.length) || actor.exit_round

    case 'not_for_profit':
      return (['LegalEntity'].includes(actor.actor_type) &&
        !['Academia'].includes(actor.category))
    case 'company_number':
    case 'vat_number':
    case 'maturity':
    case 'additional_information':
    case 'sustainability_goal':
    case 'founders':
      return ['LegalEntity'].includes(actor.actor_type)
    case 'seo_keywords':
      return !['Product'].includes(actor.actor_type)
    case 'technologies':
    case 'industries':
    case 'domains':
    case 'market':
      return ['LegalEntity', 'Product'].includes(actor.actor_type)
    case 'activities':
      return ['LegalEntity', 'Person'].includes(actor.actor_type)
    case 'product_features_a':
    case 'product_features_b':
    case 'product_features_c':
      return ['Product'].includes(actor.actor_type)
    case 'other_urls':
    case 'rss_feed':
      return actor.actor_type !== 'Person'
    default:
      return true
  }
}

export function industryValueForSuggestionValue (value, industries) {
  const industry = industries.find(i => i.name === value)

  if (industry) {
    return industry.id
  } else if (value.name !== undefined) {
    return { value: value, label: value.name }
  } else {
    return value
  }
}

export function getKeywordsFromState (displayedKeywords, store, filterableReportFields) {
  const state = store.state
  const knowledgeSharing = store.getters.knowledgeSharing
  // For every filter that is a nested property, make a special keyword that can be used to be displayed in the keyword search bar
  // Funding date
  if (state.filters.dateRanges && (state.filters.dateRanges.fundingDateStart || state.filters.dateRanges.fundingDateEnd)) {
    displayedKeywords.push({
      'facet': 'Funding Date',
      'value': {
        start: state.filters.dateRanges.fundingDateStart,
        end: state.filters.dateRanges.fundingDateEnd,
      },
    })
  }

  // Founding date
  if (state.filters.dateRanges && (state.filters.dateRanges.foundingDateStart || state.filters.dateRanges.foundingDateEnd)) {
    displayedKeywords.push({
      'facet': 'Founding Date',
      'value': {
        start: state.filters.dateRanges.foundingDateStart,
        end: state.filters.dateRanges.foundingDateEnd,
      },
    })
  }

  // Employee range
  if (state.filters.employeeRange && (state.filters.employeeRange.employeeLowerBound || state.filters.employeeRange.employeeUpperBound)) {
    displayedKeywords.push({
      'facet': 'Employees',
      'value': {
        start: state.filters.employeeRange.employeeLowerBound,
        end: state.filters.employeeRange.employeeUpperBound,
      },
    })
  }

  // Patent count range
  if (state.filters.patentCountRange && (state.filters.patentCountRange.patentCountMin || state.filters.patentCountRange.patentCountMax)) {
    displayedKeywords.push({
      'facet': 'Patents',
      'value': {
        start: state.filters.patentCountRange.patentCountMin,
        end: state.filters.patentCountRange.patentCountMax,
      },
    })
  }

  // Relationship count range
  if (state.filters.relationshipCountRange && (state.filters.relationshipCountRange.relationshipCountMin || state.filters.relationshipCountRange.relationshipCountMax)) {
    displayedKeywords.push({
      'facet': 'Total Connections',
      'value': {
        start: state.filters.relationshipCountRange.relationshipCountMin,
        end: state.filters.relationshipCountRange.relationshipCountMax,
      },
    })
  }

  // Revenue range
  if (state.filters.revenueRange && (state.filters.revenueRange.revenueMin || state.filters.revenueRange.revenueMax)) {
    displayedKeywords.push({
      'facet': 'Revenue',
      'value': {
        start: state.filters.revenueRange.revenueMin,
        end: state.filters.revenueRange.revenueMax,
      },
    })
  }

  // Custom score range
  if (state.filters.customScoreRange && (state.filters.customScoreRange.customScoreMin || state.filters.customScoreRange.customScoreMax)) {
    displayedKeywords.push({
      'facet': 'Custom Score',
      'value': {
        start: state.filters.customScoreRange.customScoreMin,
        end: state.filters.customScoreRange.customScoreMax,
      },
    })
  }

  // Claimed At Range
  if (state.filters.dateRanges && (state.filters.dateRanges.claimedAtStart || state.filters.dateRanges.claimedAtEnd)) {
    displayedKeywords.push({
      'facet': 'Claimed At',
      'value': {
        start: state.filters.dateRanges.claimedAtStart,
        end: state.filters.dateRanges.claimedAtEnd,
      },
    })
  }

  // Created At Range
  if (state.filters.dateRanges && (state.filters.dateRanges.createdAtStart || state.filters.dateRanges.createdAtEnd)) {
    displayedKeywords.push({
      'facet': 'Created At',
      'value': {
        start: state.filters.dateRanges.createdAtStart,
        end: state.filters.dateRanges.createdAtEnd,
      },
    })
  }

  // Updated At Range
  if (state.filters.dateRanges && (state.filters.dateRanges.updatedAtStart || state.filters.dateRanges.updatedAtEnd)) {
    displayedKeywords.push({
      'facet': 'Updated At',
      'value': {
        start: state.filters.dateRanges.updatedAtStart,
        end: state.filters.dateRanges.updatedAtEnd,
      },
    })
  }

  // Completeness range
  if (state.filters.completenessRange && (state.filters.completenessRange.completenessMin || state.filters.completenessRange.completenessMax)) {
    displayedKeywords.push({
      'facet': 'Completeness',
      'value': {
        start: state.filters.completenessRange.completenessMin,
        end: state.filters.completenessRange.completenessMax,
      },
    })
  }

  // Mentions range
  if (state.filters.keywords && (state.filters.keywords.find(k => k.facet === 'mentionsMin') || state.filters.keywords.find(k => k.facet === 'mentionsMax'))) {
    displayedKeywords.push({
      'facet': 'Mentions',
      'value': {
        start: (state.filters.keywords.find(k => k.facet === 'mentionsMin') || {}).value || null,
        end: (state.filters.keywords.find(k => k.facet === 'mentionsMax') || {}).value || null,
      },
    })
  }

  // Total funding range
  if (state.filters.totalFunding && (state.filters.totalFunding.minTotalFunding || state.filters.totalFunding.maxTotalFunding)) {
    displayedKeywords.push({
      'facet': 'Total funding',
      'value': {
        start: state.filters.totalFunding.minTotalFunding,
        end: state.filters.totalFunding.maxTotalFunding,
      },
    })
  }

  // Report fields
  if (knowledgeSharing && filterableReportFields && filterableReportFields.length > 0) {
    const reportFilters = state.filters.reportFilters

    filterableReportFields.forEach(reportField => {
      let reportFieldName
      if (reportField.type === 'score' || reportField.type === 'number' || reportField.type === 'date') {
        reportFieldName = 'report_field_' + reportField.id

        if (reportFilters[reportFieldName + '_min'] || reportFilters[reportFieldName + '_max']) {
          displayedKeywords.push({
            'facet': reportField.label,
            'type': 'report',
            'meta': reportField,
            'value': {
              start: reportFilters[reportFieldName + '_min'],
              end: reportFilters[reportFieldName + '_max'],
            },
          })
        }
      } else if (['options', 'multi_select', 'checkbox'].includes(reportField.type)) {
        reportFieldName = 'report_field_' + reportField.id

        if (reportFilters[reportFieldName] && reportFilters[reportFieldName].length > 0) {
          reportFilters[reportFieldName].forEach(item => {
            displayedKeywords.push({
              'facet': reportField.label,
              'type': 'report',
              'meta': reportField,
              'value': item,
            })
          })
        }
      }
    })
  }

  return displayedKeywords
}

export function assertArray (data) {
  if (Array.isArray(data)) {
    return data
  } else {
    console.error('Expected array, but got', data)
    Raven.setExtraContext({ data })
    Raven.captureMessage('Expected array, but got ' + typeof data)
    return []
  }
}

export function ecosystemMemberHasAccessToChallenge (challenge, userId, accessibleChallengeStatusses) {
  return challenge.user_is_invited ||
    challenge.user_id === userId ||
    (accessibleChallengeStatusses.includes(challenge.status) && challenge.visibility === 'public')
}

export function shortTitle (title) {
  return title.length > 70 ? title.substring(0, 70) + '...' : title
}

export function getCardsPerCarouselPageBasedOnWindowWidth (windowWidth) {
  if (windowWidth <= 500) {
    return 1
  } else if (windowWidth <= 750) {
    return 2
  } else {
    return 3
  }
}

export function getSmallCardsPerCarouselPageBasedOnWindowWidth (windowWidth) {
  if (windowWidth <= 576) {
    return 1
  } else if (windowWidth <= 650) {
    return 2
  } else if (windowWidth <= 768) {
    return 3
  } else if (windowWidth <= 1000) {
    return 4
  } else if (windowWidth <= 1200) {
    return 5
  } else {
    return 6
  }
}

export function getDomainFromUrl (url) {
  return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0]
}

export function copyToClipboard (text) {
  const textArea = document.createElement('textarea')
  textArea.style.position = 'fixed'
  textArea.style.top = 0
  textArea.style.left = 0
  textArea.style.width = '2em'
  textArea.style.height = '2em'
  textArea.style.padding = 0
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'
  textArea.style.background = 'transparent'
  textArea.value = text

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (err) {
    console.log('Unable to copy')
  }
  document.body.removeChild(textArea)
}

export function splitCtaText (text) {
  // don't use split, in case the first char is {
  const textBeforeLink = text.replace(/{.*/, '') || ''
  const textInsideLink = text.replace(/.*{/, '').replace(/}.*/, '') || 'Upgrade'
  const textAfterLink = text.replace(/.*}/, '') || ''
  return [textBeforeLink, textInsideLink, textAfterLink]
}

// NOTE: this isn't waterproof: https://stackoverflow.com/questions/5002111/how-to-strip-html-tags-from-string-in-javascript
export function stripHtmlTags (text) {
  return text.replace(/<\/?[^>]+(>|$)/g, '')
}

export function stripHtmlTagsWithSpaces (text) {
  return text.replace(/<\/?[^>]+(>|$)/g, ' ')
}

// Convert plain-text newlines to <br> so they render on a new line in v-html content.
export function nl2br (text) {
  if (!text) {
    return text
  }

  return String(text).replace(/\r\n|\r|\n/g, '<br>')
}

export function getUriDomain (sourceUrl) {
  if (!sourceUrl) {
    return
  }

  const pathArray = sourceUrl.split('/')
  const domain = pathArray[2]

  if (!domain) {
    return
  }

  return domain.replace('www.', '')
}

function getTextForLikers (likedByUsers) {
  let popupContent = 'Liked by '
  const likedUserNames = likedByUsers
    .map(user => user.claimedActor || user.name)

  if (likedUserNames.length > 3) {
    const nrOfothers = likedUserNames.length - 2
    popupContent += likedUserNames.slice(0, 2).join(', ') + ` and ${nrOfothers} others`
  } else if (likedUserNames.length > 2) {
    popupContent += likedUserNames
      .slice(0, likedUserNames.length - 1)
      .join(', ') + ' and ' + likedUserNames[likedUserNames.length - 1]
  } else {
    popupContent += likedUserNames.join(' and ')
  }

  return popupContent
}

export function getTooltipForLikes (likers) {
  if (!likers || !likers.length) {
    return
  }

  return getTextForLikers(likers)
}

export function getLabelForChallengeStatus (status) {
  if (['new', 'open', 'solved'].includes(status)) {
    return this.$t('challenges_' + status).toUpperCase()
  }

  return ''
}

export function getExternalLinkFromItem (data) {
  if (data.meta && data.meta.length > 0) {
    const linkMetaEntry = data.meta.find(meta => meta.key && meta.key === 'url') || data.meta.find(meta => meta.key && meta.key === 'link') || data.meta.find(meta => meta.key && meta.key === 'video_link')

    if (linkMetaEntry) {
      if (linkMetaEntry.url) {
        return linkMetaEntry.url
      }

      if (linkMetaEntry.value) {
        return linkMetaEntry.value
      }
    }

    return getInternalFileUrlForResource(data)
  }
}

export function getInternalFileUrlForResource (data) {
  return data.actor_id && data.actor_id[0] ? `${window.location.origin}/api/actors/${data.actor_id[0].id}/files/${data.sql_media_id}` : `${window.location.origin}/api/files/${data.sql_media_id}`
}

export function getImageForAnnouncement (announcement) {
  if (!announcement || !announcement.image || announcement.image === '') {
    return getDefaultFallbackImageUrl()
  }
  return `/notifications/${announcement.id}/image`
}

export function getImageForCommunity (community) {
  if (!community || !community.image || community.image === '') {
    return getDefaultFallbackImageUrl()
  }

  return '/api/communities/' + community.id + '/image'
}

export function getDefaultFallbackImageUrl () {
  if (window.config.onboarding_image_url) {
    return window.config.onboarding_image_url
  }

  return '/images/ds-fallback-1920.png'
}

export function getImageForSpottingArea (spottingArea) {
  if (!spottingArea || !spottingArea.image || spottingArea.image === '') {
    return getDefaultFallbackImageUrl()
  }
  return '/api/spotting-areas/' + spottingArea.id + '/image'
}

export function getImageForPortfolio (portfolio) {
  if (!portfolio || !portfolio.image || portfolio.image === '') {
    return getDefaultFallbackImageUrl()
  }
  return portfolio.image
}

export function isUserARemovedUser (user) {
  if (user.email) {
    return user.email.endsWith('@datascouts-bin.eu')
  }

  if (user.name) {
    return user.name === 'removed user'
  }
}

export function getConnectionsForActor (data, allConnectionTypes) {
  const hasData = Object.keys(data).length > 0

  if (allConnectionTypes.length === 0) {
    return []
  }

  if (hasData) {
    const orderedConnections = [
      ...allConnectionTypes.filter(r => !['main_company'].includes(r.name)),
    ]

    return orderedConnections
      .reduce(
        (allRelations, relationType) => [
          ...allRelations,
          ...(data[relationType.name] || []).map(relation => {
            return {
              name: relation.to_name,
              id: relation.to,
              relation_id: relation.relationship_id,
              legend: relation.legend,
              activities: relation.activities,
              domains: relation.domains,
              category: relation.category,
              membership: relation.membership,
              industries: relation.industries,
              stage: relation.stage,
              type: relationType.name,
              label: relationType.label,
              tags: relation.tags,
              logo: relation.logo,
              actorType: relation.actor_type,
              featured_image_url: relation.featured_image_url,
              comment: relation.comment,
              start: relation.start,
              end: relation.end,
              score: relation.score,
              status: relation.status,
              country: relation.country,
              short_description: relation.short_description,
              has_access: relation.has_access,
            }
          }),
        ],
        [],
      )
  }

  return []
}

export function mapNewGlobalSearchResultToLegacyFormat (globalSearchResults) {
  globalSearchResults = globalSearchResults.map(actor => {
    return {
      id: actor.result.id,
      icon: actor.result.actor_type === 'Product' ? 'icons' : '',
      name: actor.result.name ?? actor.result.title,
      actor_type: actor.result.actor_type,
      short_description: actor.result.description,
      url: actor.result.external_url,
      actor_id: actor.result.actor_id,
    }
  })

  // Return the combined results without duplicates
  return _uniqBy(globalSearchResults, 'id')
}

export function mapNewGlobalSearchResultForActorMentions (globalSearchResults) {
  globalSearchResults = globalSearchResults.map(actor => {
    return {
      name: actor.result.name, // We need this to show up in the popup
      label: actor.result.name, // We need this to show in the tag itself
      value: actor.result.id,
      actor_type: actor.result.actor_type,
    }
  })

  return _uniqBy(globalSearchResults, 'value')
}

export function baseUrl (url) {
  const domainRegex = /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9.-]+)\//

  const matches = url.match(domainRegex)
  return matches ? matches[1] : ''
}

/**
 * Whether `email` belongs to one of `domains`, each given with its leading '@'.
 *
 * Matches on the domain suffix rather than a bare `includes`, so an address such as
 * name@example.nl.attacker.com does not pass for '@example.nl'. Pure so the router guard and the
 * page component can share it — the page cannot import from the router, which imports the page.
 */
export function matchesEmailDomain (email, domains = []) {
  const address = String(email || '').toLowerCase()

  return (domains || []).some(domain => address.endsWith(String(domain).toLowerCase()))
}
